import React from 'react';

import { Paragraph, Spacer, Text } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import YesAndNo from '../../../Widgets/YesAndNo';
import { MORE_RULES } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function MoreRules({ setSectionValues, section }: Props): JSX.Element {
  function onNoRules(): void {
    setSectionValues({
      [MORE_RULES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRules(): void {
    setSectionValues({
      [MORE_RULES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <Spacer marginBottom="sm">
        <Text fontType="h6">Additional rules</Text>
        <Text> (optional)</Text>
      </Spacer>
      <Paragraph fontType="bodySmallHeading">Want to add more rules to your lease?</Paragraph>
      <Paragraph marginBottom="sm">
        You can customize your lease by selecting rules for property usage, resident activities, and the keys. You can
        also add your own rules.
      </Paragraph>
      <YesAndNo
        yesHandler={onYesRules}
        noHandler={onNoRules}
        yesActive={section.getFieldValue(MORE_RULES.FIELD_NAME.IS_ENABLED)}
      />
    </>
  );
}
